import { render, staticRenderFns } from "./EditLoan.vue?vue&type=template&id=5f700960"
import script from "./EditLoan.vue?vue&type=script&lang=js"
export * from "./EditLoan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports